module.exports = __webpack_public_path__ + "img/logo_v2_horizontal.6fd588e9.svg";